/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export default {
    preferredAudioCodecs: ['mp4a.40.2'],
    preferredTextLanguage: '',
    preferredTextRole: '',
    streaming: {
        inaccurateManifestTolerance: 1,
        rebufferingGoal: 1,
        bufferBehind: 6,
        bufferingGoal: 18,
        stallSkip: 0.1,
        startAtSegmentBoundary: false,
    },
    manifest: {
        defaultPresentationDelay: 10,
        hls: {
            ignoreTextStreamFailures: true,
            ignoreImageStreamFailures: true,
        },
        dash: {
            ignoreMinBufferTime: true,
            // TODO: Will observe performance and replace with internal API(Once available)
            clockSyncUri: 'https://time.akamai.com',
            ignoreEmptyAdaptationSet: true,
        },
    },
    abr: {
        enabled: true,
        defaultBandwidthEstimate: 230000,
        switchInterval: 6,
    },
};
